module.exports = global["jQuery"] = require("-!F:\\qsujuan\\正邦项目\\q钦天导航\\qintian\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");